module.exports = __webpack_public_path__ + "static/media/Caleb_Harper_desktop.cb04316f.jpg";